module.exports = "/../../dist/frontend/images/R-DAM_1385365_mobile.webp?2a16f793a6da9be3b039487b5e2ab475";